import { Link } from "react-router-dom";
export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel">
      <h1 className="font-serif text-4xl md:text-5xl font-bold">Payment cancelled</h1>
      <p className="mt-4 text-charcoal/70">No charge was made. You can try again anytime.</p>
      <Link to="/workshops" className="mt-8 inline-block rounded-full bg-terracotta text-white px-6 py-3 font-semibold">Back to Workshops</Link>
    </div>
  );
}
